import React, { useState, useEffect } from 'react';
import Breadcrumb from '../../components/Breadcrumb'


export default function PageRules() {
    const [tab, setTab] = useState('step1rulesTab');
    const handleTabClick = (tabId) => {
        setTab(tabId);
    };


    return (
        <>
            <Breadcrumb className="" breadcrumbIcon="UserCircleSvg" breadcrumbHeading="Rules" />
            <div className="container-lg cl-custome3">
                <div className="common-box">
                    <div className="common-box rules-bx">
                        <div className="alb-tabs">
                            {/* Step 1 & Step 2 Rules Tabing btn */}
                            <div className="common-tabs-bx">
                                <div className={`ctb-item ${tab === 'step1rulesTab' ? 'active' : ''}`} onClick={() => handleTabClick('step1rulesTab')}>Step 1</div>
                                <div className={`ctb-item ${tab === 'step2rulesTab' ? 'active' : ''}`} onClick={() => handleTabClick('step2rulesTab')}>Step 2</div>
                            </div>
                            {/* --- Step 1 & Step 2 Rules Tabing btn end --- */}
                        </div>
                        <div className="alb-data">
                            {/* Step 1 Rules btn */}
                            <div className={`row row-gap-0 ${tab === 'step1rulesTab' ? '' : 'd-none'} `} id="acActive">

                                <div className="legal-content">
                                    <div className="legal-heading">01. Profit Target</div>
                                    <p>You must achieve a 10% profit target to pass the challenge without breaking any rules.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">02. Maximum Drawdown Limit</div>
                                    <p>The overall max drawdown limit is 6% while the daily max drawdown limit is 3%.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">03. Minimum Trading Days</div>
                                    <p>You must trade on at least 5 separate days to complete each stage of evaluation, however there’s no upper limit on trading days.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">04 Profit Limit Rule</div>
                                    <p>No single trade can exceed 30% of the profit target in a Challenge Account or the requested payout amount in a Real Account.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">05 Profit Sharing</div>
                                    <p>A minimum 1% profit is required to apply for payout and you can get up to 100% profit share from the third month onwards.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">Hedging</div>
                                    <p>Hedging is restricted to promote disciplined trading and maintain a structured risk approach.</p>
                                </div>

                                <div className="legal-content">
                                    <p>At FundedSkill, you are allowed to place multiple trades on the same pair; however, how they are classified depends on the time gap between them. To treat trades as separate orders, there must be at least a three-minute gap.</p>
                                </div>

                                <div className="legal-content">
                                    <p>The 3% daily drawdown is based only on one thing: the highest value between your starting balance and your starting equity at market open. Once that number is set for the day, it does not change, even if you make profits while trading.</p>

                                    <p>A breach happens the moment your equity dips below that 3% buffer, whether the drop comes from a floating loss or a closed loss.</p>

                                    <p>Example using a GBP/JPY position:</p>

                                    <div className="legal-heading mt-3">Day 1:</div>
                                    <p>You begin the session with $5000 in both balance and equity.</p>
                                    <p>3% of $5000 is $150, which means your equity must stay above $4850 for the entire trading day.</p>

                                    <div className="legal-heading mt-3">Day 2:</div>
                                    <p>You start with a $5100 balance, and your open GBP/JPY trade is showing a $100 unrealized gain.</p>
                                    <p>That makes your starting equity $5200.</p>

                                    <p>3% of $5200 is $156, so your minimum allowed equity for the day becomes $5044.</p>
                                    <p>Profits made during the day won’t give you a wider buffer; only your starting numbers decide the limit.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">For example:</div>
                                    <p>If you open a trade at 9:15 AM and another at 9:16 AM on the same pair (e.g., GBP/JPY), these will be combined as one order.</p>
                                    <p>But if the second trade is placed at 9:18 AM, they will be counted as two separate orders. This rule is only applicable to trades within the same pair. If you're trading different pairs, they will be recognized as separate positions regardless of timing.</p>
                                    <p>This rule applies only to trades within the same pair. If you place trades on different pairs, they will be considered separate positions regardless of the time difference.</p>
                                    <p>For example:</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">For example:</div>
                                    <p>A trade in GBP/JPY at 9:15 AM and another in GBP/JPY at 9:18 AM will be two separate orders.</p>
                                    <p>A trade in GBP/JPY at 9:15 AM and a trade in USD/CHF at 9:16 AM will automatically be treated as multiple positions.</p>
                                    <p>This policy helps FundedSkill maintain accurate trade monitoring and risk management</p>
                                    <p>This guideline is maintained by FundedSkill to ensure accurate trade monitoring and proper risk management.</p>
                                </div>

                                <div className="legal-content">
                                    <ul>
                                        <li>Copy trading is completely allowed, feel free to use your favorite strategies.</li>
                                        <li>EA (Expert Advisors) are also allowed.</li>
                                        <li>If you need a break, you can request to freeze your account for any period between 1 day and 3 months to avoid termination.</li>
                                        <li>The Daily Loss (DL) and any position must not exceed 3% of the account balance to manage risk effectively. If it does, it will be treated as a rule violation.</li>
                                    </ul>
                                    <p className='mt-4'><strong>Note</strong>: Account size $ are indicative, and your account will be automatically terminated if rules are violated.</p>
                                </div>


                            </div>

                            {/* Step 2 Rules btn */}
                            <div className={`row row-gap-0 ${tab === 'step2rulesTab' ? '' : 'd-none'} `} id="acActive">
                                <div className="legal-content">
                                    <div className="legal-heading">01. Profit Target</div>
                                    <p>You must achieve a 8% profit target to pass the first step and 5% to pass the second step without breaking any rules.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">02. Maximum Drawdown Limit</div>
                                    <p>The overall max drawdown limit is 10% while the daily max drawdown limit is 5%.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">03. Minimum Trading Days</div>
                                    <p>You must trade on at least 5 separate days to complete each stage of evaluation, however there’s no upper limit on trading days.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">04 Profit Limit Rule</div>
                                    <p>No single trade can exceed 30% of the profit target in a Challenge Account or the requested payout amount in a Real Account.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">05 Profit Sharing</div>
                                    <p>A minimum 1% profit is required to apply for payout and you can get up to 100% profit share from the third month onwards.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">Hedging</div>
                                    <p>Hedging is restricted to promote disciplined trading and maintain a structured risk approach.</p>
                                </div>

                                <div className="legal-content">
                                    <p>At FundedSkill, you are allowed to place multiple trades on the same pair; however, how they are classified depends on the time gap between them. To treat trades as separate orders, there must be at least a three-minute gap.</p>
                                </div>


                                <div className="legal-content">
                                    <p>The 5% daily drawdown is decided at the start of the trading day. It’s based on whichever is higher: your starting balance or your starting equity. Once that figure is locked in, it doesn’t adjust during the day, even if you make intraday profits.</p>

                                    <p>A violation happens the moment your equity drops below that 5% threshold, whether the drop comes from floating or closed losses.</p>

                                    <p>Example using a GBP/JPY trade:</p>

                                    <div className="legal-heading mt-3">Day 1:</div>
                                    <p>You begin the day with $5000 in both balance and equity.</p>
                                    <p>5% of $5000 is $250, so your equity must stay above $4750 for the entire day.</p>

                                    <div className="legal-heading mt-3">Day 2:</div>
                                    <p>Your starting balance is $5100, and you’re holding a GBP/JPY position showing a $100 floating profit.</p>
                                    <p>This makes your starting equity $5200. 5% of $520 is $260.</p>
                                    <p>That means your equity for the day must remain above $4940.</p>
                                    <p>Intraday gains won’t widen this limit; the drawdown is determined only by the numbers at the start of the day.</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">For example:</div>
                                    <p>If you open a trade at 9:15 AM and another at 9:16 AM on the same pair (e.g., GBP/JPY), these will be combined as one order.</p>
                                    <p>But if the second trade is placed at 9:18 AM, they will be counted as two separate orders. This rule is only applicable to trades within the same pair. If you're trading different pairs, they will be recognized as separate positions regardless of timing.</p>
                                    <p>This rule applies only to trades within the same pair. If you place trades on different pairs, they will be considered separate positions regardless of the time difference.</p>
                                    <p>For example:</p>
                                </div>

                                <div className="legal-content">
                                    <div className="legal-heading">For example:</div>
                                    <p>A trade in GBP/JPY at 9:15 AM and another in GBP/JPY at 9:18 AM will be two separate orders.</p>
                                    <p>A trade in GBP/JPY at 9:15 AM and a trade in USD/CHF at 9:16 AM will automatically be treated as multiple positions.</p>
                                    <p>This policy helps FundedSkill maintain accurate trade monitoring and risk management</p>
                                    <p>This guideline is maintained by FundedSkill to ensure accurate trade monitoring and proper risk management.</p>
                                </div>

                                <div className="legal-content">
                                    <ul>
                                        <li>Copy trading is completely allowed, feel free to use your favorite strategies.</li>
                                        <li>EA (Expert Advisors) are also allowed.</li>
                                        <li>If you need a break, you can request to freeze your account for any period between 1 day and 3 months to avoid termination.</li>
                                        <li>The Daily Loss (DL) and any position must not exceed 5% of the account balance to manage risk effectively. If it does, it will be treated as a rule violation.</li>
                                    </ul>
                                    <p className='mt-4'><strong>Note</strong>: Account size $ are indicative, and your account will be automatically terminated if rules are violated.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
